/**
 * OTP — Prova social do cliente.
 *
 * One video, so the work here is small: hold the source back until the section
 * is close to the screen, play it muted while it is visible, pause when it is
 * not, and let the viewer turn the sound on.
 */

class OtpCustomerProof extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';

    this.video = this.querySelector('video[data-src]');
    if (!this.video) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.observe();
    this.bindSound();
  }

  observe() {
    /* attach the file a screen early, so it is ready by the time it is seen */
    const attach = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.attach();
          attach.unobserve(entry.target);
        });
      },
      { rootMargin: '500px 0px' }
    );

    const playback = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.attach();
            const attempt = this.video.play();
            if (attempt && attempt.catch) attempt.catch(() => {});
          } else if (!this.video.paused) {
            this.video.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    attach.observe(this.video);
    playback.observe(this.video);
    this.observers = [attach, playback];
  }

  attach() {
    const video = this.video;
    if (video.dataset.attached) return;
    video.dataset.attached = 'true';

    const wide = window.matchMedia('(min-width: 750px)').matches;
    const source = document.createElement('source');
    source.src = (wide && video.dataset.srcLarge) || video.dataset.src;
    if (video.dataset.type) source.type = video.dataset.type;
    video.appendChild(source);
    video.preload = 'metadata';
    video.load();
    video.addEventListener('loadeddata', () => video.classList.add('is-loaded'), { once: true });
  }

  bindSound() {
    const button = this.querySelector('[data-sound]');
    if (!button) return;

    button.addEventListener('click', () => {
      const turningOn = this.video.muted;
      this.video.muted = !turningOn;
      button.setAttribute('aria-pressed', turningOn ? 'true' : 'false');
      if (turningOn) {
        const attempt = this.video.play();
        if (attempt && attempt.catch) attempt.catch(() => {});
      }
    });
  }

  disconnectedCallback() {
    (this.observers || []).forEach((observer) => observer.disconnect());
  }
}

if (!customElements.get('otp-customer-proof')) {
  customElements.define('otp-customer-proof', OtpCustomerProof);
}
